import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../http/query-client';
import {BackendResponse} from '../../http/backend-response/backend-response';
import {PaginatedBackendResponse} from '../../http/backend-response/pagination-response';
import {Product} from '../product';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';

const endpoint = 'billing/products';

export interface FetchProductsResponse extends BackendResponse {
  products: Product[];
}

export function useProducts(loader?: string, role?: string) {
  return useQuery<FetchProductsResponse>({
    queryKey: [endpoint, role],
    queryFn: () => fetchProducts(role),
    staleTime: 0, 
    initialData: () => {
      if (loader) {
        // @ts-ignore
        return getBootstrapData().loaders?.[loader];
      }
    },
  });
}

function fetchProducts(role?: string): Promise<FetchProductsResponse> {
  // Ajoute le paramètre `role` à l'endpoint si fourni
  const url = role ? `${endpoint}?role=${role}` : endpoint;

  return apiClient
    .get<PaginatedBackendResponse<Product>>(url)
    .then(response => {
      return {products: response.data.pagination.data};
    });
}
